import { ExprValue } from '../../ExprValue';
import { createReducer } from './Reducer';
const { asDecimal } = ExprValue;
export const sum = createReducer((memo, next) => {
    switch (typeof memo) {
        case 'number': {
            switch (typeof next) {
                case 'number':
                    return memo + next;
                case 'string':
                    return asDecimal(next).add(memo);
                case 'object':
                    return next.add(memo);
            }
            break;
        }
        case 'object': {
            switch (typeof next) {
                case 'number':
                case 'string':
                case 'object':
                    return memo.add(next);
            }
            break;
        }
        case 'string': {
            switch (typeof next) {
                case 'number':
                case 'string':
                    return asDecimal(memo).add(next);
                case 'object':
                    return next.add(memo);
            }
            break;
        }
        default: {
            throw new Error(`Unknown operand types ${typeof memo} + ${typeof next}`);
        }
    }
});
